module.exports = __webpack_public_path__ + "img/5G-02-06.4a60a3a0.png";